import EgyszeruKerdesDto from 'app/admin/egyszerukerdes/dto/EgyszeruKerdesDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class EgyszeruKerdesTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'egyszeruKerdesTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, EgyszeruKerdesDto)))
				.catch(reject);
		});
	}
}

export default new EgyszeruKerdesTableService();
